import { ApiResponse } from '../models/apiResponse';
import { User as UserModel } from '../models/user';
import { apiRequests as requests } from './http-client';

const User = {
  confirmOnboardingManual: () =>
    requests
      .post<ApiResponse<{ user: UserModel }>>('/v1/user/confirm-manual')
      .then((response) => response.data),
};

export default User;
